import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { FieldValues } from "react-hook-form";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { corporateHost } from "~/Utils";
import { CentralizedRestrictedItemsSections } from "../RestrictedItemsSection/RestrictedItemsSections";
import { CentralizedRestrictedItemsSectionsList } from "../RestrictedItemsSection/RestrictedItemsSectionsList";

export const CentralizedRestrictedItems = () => {
  const query = useQuery();
  const navigate = useNavigate();
  
  const travellersInfoCard =[
    {
      label: "Checked-In & Cabin Restrictions Content",
      key: "centralizedRestrictedItemsCheckedInCabinRestrictionsContent",
      children: <CentralizedRestrictedItemsSections />
    },
    {
      label: "Checked-In & Cabin Restrictions Image",
      key: "centralizedRestrictedItemsCheckedInCabinRestrictionsImage",
      children: <CentralizedRestrictedItemsSectionsList />
    },
    {
        label: "Cabin-Only Restrictions Content",
        key: "centralizedRestrictedItemsCabinOnlyRestrictionsContent",
        children: <CentralizedRestrictedItemsSections />
    },
    {
        label: "Cabin-Only Restrictions Image",
        key: "centralizedRestrictedItemsCabinOnlyRestrictionsImage",
        children: <CentralizedRestrictedItemsSectionsList />
    }
  ]


  return (
    // <ContentWrapper>
      <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={travellersInfoCard}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
